/** @format */
import React, { useState } from 'react';
import Promise from 'bluebird';
import SignInCard from '../../components/SignInCard';
import Screensaver from '../../components/Screensaver';
import Fade from '@material-ui/core/Fade';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';
import SwitchIcon from '@material-ui/icons/RepeatTwoTone';
import useIdle from 'react-use/lib/useIdle';
import LoginCode from './LoginCode';

// Can use Storage from aws-amplify but hardcoded for now.
const BACKGROUND_IMAGE =
  'https://s3-ap-southeast-2.amazonaws.com/countmein-assets-dev/new-background.png';
const BACKGROUND_TINT = 'rgba(27, 94, 32, 0.75)';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
    background: `linear-gradient(${BACKGROUND_TINT},${BACKGROUND_TINT}), url("${BACKGROUND_IMAGE}") no-repeat center center fixed`,
    backgroundSize: 'cover'
  },
  switcher: {
    position: 'fixed',
    marginTop: -20,
    marginLeft: 20
  },
  card: {
    placeSelf: 'center',
    gridColumn: '2 / span 2',
    gridRow: '2 / span 2'
  },
  screensaver: {
    justifySelf: 'center',
    gridColumn: '1 / span 4',
    gridRow: '2 / span 2'
  }
}));

const EMAIL_SIGNIN = Symbol('email_signin');
const CODE_SIGNIN = Symbol('code_signin');

const SignInPage = () => {
  const [state, setState] = React.useState({
    signInType: CODE_SIGNIN,
    showSwitcher: false
  });
  const classes = useStyles();
  const [active, setActive] = useState(false);
  const [animate, setAnimate] = useState(false);
  const isIdle = useIdle(10000e3);

  const handleActivate = () => {
    setAnimate(false);
    setTimeout(() => {
      setActive(true);
    }, 100);
  };

  React.useEffect(() => {
    let um = false;
    setState(oldState => ({ ...oldState, showSwitcher: false }));
    Promise.delay(500).then(() => {
      if (um) return;
      setState(oldState => ({ ...oldState, showSwitcher: true }));
    });
    return () => {
      um = true;
    };
  }, [state.signInType]);

  React.useEffect(() => {
    setAnimate(true);
  }, []);

  React.useEffect(() => {
    if (isIdle && active) {
      setActive(false);
      setAnimate(true);
    }
  }, [isIdle, active]);

  const switchSignIn = React.useCallback(() => {
    setState(oldState => ({
      ...oldState,
      signInType: oldState.signInType === CODE_SIGNIN ? EMAIL_SIGNIN : CODE_SIGNIN
    }));
  }, []);

  return (
    <div onClick={handleActivate} className={classes.root}>
      {active ? (
        <div className={classes.card}>
          {state.showSwitcher && (
            <Zoom in={state.showSwitcher}>
              <Fab
                data-testid="signInSwitcher"
                size="small"
                className={classes.switcher}
                onClick={switchSignIn}>
                <SwitchIcon />
              </Fab>
            </Zoom>
          )}
          {state.signInType === CODE_SIGNIN && <LoginCode />}
          {state.signInType === EMAIL_SIGNIN && <SignInCard />}
        </div>
      ) : (
        <Fade timeout={{ enter: 500 }} in={animate}>
          <div className={classes.screensaver}>
            <Screensaver />
          </div>
        </Fade>
      )}
    </div>
  );
};

export default SignInPage;
